/* eslint-disable prefer-arrow-callback */
/* eslint-disable prefer-template */
/**
 * Layer Type: HP Resource Slider
 *
 * @package  embark
 * @since    1.0.0
 */

/**
 * Import dependencies.
 */
import $ from 'jquery';
import 'slick-carousel';

/**
 * Slider layers
 *
 * @type {NodeList}
 */
const blockHPSlider = document.querySelectorAll('.hp-resource-slider');

/**
 * Do synchronized slick sliders.
 */
function initBlockHPResourceSlider() {
	$(blockHPSlider).each(
		function () {
			// This layer instance.
			// const $this = $(this);

			// This layer's content slider.
			const $slider = $(this).find('.hp-resource-slider__slides');

			// Initialize slider if more than one slide.
			if ($slider.find('.hp-resource-slider__slide').length > 1) {
				// Content slider properties.
				const sliderProps = {
					adaptiveHeight: true,
					arrows: false,
					dots: false,
					draggable: true,
					fade: false,
					mobileFirst: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					responsive: [{
						breakpoint: 834,
						settings: {
							slidesToShow: 2,
						},
					}],
				};

				// Initialize the content slider.
				$slider.slick(sliderProps);

				// Custom prev/next links.
				$('.hp-resource-slider__nav--next').click(function () {
					$slider.slick('slickNext');
				});

				$('.hp-resource-slider__nav--prev').click(function () {
					$slider.slick('slickPrev');
				});
			}
		},
	);
}

window.addEventListener('DOMContentLoaded', initBlockHPResourceSlider);
